<div class="overlay" *ngIf="showLoader">
    <static-loader [text]="text" color="white"></static-loader>
  </div>
  